// src/pages/finances/AjouterEntree.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

// ===== STYLES =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }
  .form-control-modern.is-invalid, .form-select-modern.is-invalid {
    border-color: ${COLORS.danger};
  }
  .form-control-modern.is-invalid:focus, .form-select-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239,68,68,0.08);
  }

  .form-text-modern {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  .input-icon-wrapper {
    position: relative;
  }
  .input-icon {
    position: absolute;
    left: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 1rem;
    z-index: 2;
  }
  .form-control-modern.with-icon,
  .form-select-modern.with-icon {
    padding-left: 2.2rem;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  /* Loading */
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }
  .loading-ring-wrapper {
    position: relative;
    width: 70px;
    height: 70px;
  }
  .loading-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #e9edf2;
    border-top-color: ${COLORS.primary};
    animation: spin 0.8s linear infinite;
  }
  .loading-ring-inner {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border-radius: 50%;
    border: 2px solid #e9edf2;
    border-bottom-color: ${COLORS.secondary};
    animation: spin 0.6s linear infinite reverse;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function AjouterEntree() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [temples, setTemples] = useState([]);
  const [typesRevenus, setTypesRevenus] = useState([]);

  const [formData, setFormData] = useState({
    date_at: new Date().toISOString().split('T')[0],
    matri_revenu: '',
    total: '',
    matri_eglise: ''
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }
        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;

        // Charger les temples
        const templesRes = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&parent=filiale&limit=1000`);
        const templesData = await templesRes.json();
        if (templesData.success) {
          setTemples(templesData.eglises || []);
        }

        // Charger les types de revenus
        const typesRes = await fetch(`https://josephsbusiness.com/api/type_revenus.php?user_id=${userId}`);
        const typesData = await typesRes.json();
        if (typesData.success) {
          setTypesRevenus(typesData.types || []);
        }

        if (id) {
          const entreeRes = await fetch(`https://josephsbusiness.com/api/entrees.php?user_id=${userId}&id=${id}`);
          const entreeData = await entreeRes.json();
          if (entreeData.success && entreeData.entree) {
            const entree = entreeData.entree;
            setFormData({
              date_at: entree.date_at,
              matri_revenu: entree.matri_revenu || '',
              total: entree.total,
              matri_eglise: entree.matri_eglise || ''
            });
          }
        }
      } catch (err) {
        setError('Erreur lors du chargement des données: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.date_at) errors.date_at = 'La date est requise';
    if (!formData.matri_revenu) errors.matri_revenu = 'Le type de revenu est requis';
    if (!formData.total) errors.total = 'Le montant est requis';
    else if (isNaN(formData.total) || parseFloat(formData.total) <= 0) {
      errors.total = 'Le montant doit être un nombre positif';
    }
    if (!formData.matri_eglise) errors.matri_eglise = 'Le temple est requis';
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSaving(true);
    setError(null);

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const url = id
        ? `https://josephsbusiness.com/api/entrees.php?user_id=${userId}&id=${id}`
        : `https://josephsbusiness.com/api/entrees.php?user_id=${userId}`;

      const method = id ? 'PUT' : 'POST';

      const dataToSend = {
        date_at: formData.date_at,
        matri_revenu: formData.matri_revenu,
        total: parseFloat(formData.total),
        matri_eglise: formData.matri_eglise
      };
      if (id) dataToSend.id = id;

      if (!id) {
        const date = new Date();
        const random = Math.floor(Math.random() * 1000);
        dataToSend.matricule = `ENT${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}${random}`;
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          window.location.href = '/finances/entrees?reload=' + Date.now();
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
  return (
    <>
      <Header />
      <div
        className="main main-app p-3 p-lg-4"
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div className="text-center" style={{ maxWidth: '420px', padding: '2rem' }}>
          {/* Icône animée */}
          <div className="loading-logo-wrapper mb-4">
            <div className="loading-logo-pulse">
              <div className="loading-logo-circle">
                <i className="ri-money-euro-circle-line" style={{ fontSize: '2.5rem', color: COLORS.primary }}></i>
              </div>
            </div>
          </div>

          {/* Titre avec points de suspension animés */}
          <h5 className="fw-bold mb-2" style={{ color: COLORS.primaryDark }}>
            Chargement en cours
            <span className="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </h5>
          <p className="text-muted small mb-4">Préparation du formulaire, veuillez patienter...</p>

          {/* Barre de progression animée */}
          <div className="loading-progress-wrapper mx-auto" style={{ width: '80%' }}>
            <div
              className="loading-progress-track"
              style={{
                height: '4px',
                borderRadius: '4px',
                background: '#e9edf2',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <div
                className="loading-progress-bar"
                style={{
                  height: '100%',
                  width: '0%',
                  background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary}, ${COLORS.primary})`,
                  backgroundSize: '200% 100%',
                  borderRadius: '4px',
                  animation: 'loadingProgress 2s ease-in-out infinite, shimmer 1.5s linear infinite'
                }}
              />
            </div>
          </div>

          {/* Badge de statut */}
          <div className="mt-3">
            <span
              className="badge"
              style={{
                background: `${COLORS.primary}10`,
                color: COLORS.primary,
                borderRadius: '4px',
                padding: '0.3rem 1rem',
                fontSize: '0.7rem',
                fontWeight: '500',
                border: `1px solid ${COLORS.primary}20`
              }}
            >
              <i className="ri-loader-4-line me-1" style={{ animation: 'spin 1s linear infinite' }}></i>
              Préparation...
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @keyframes loadingProgress {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }

        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        @keyframes pulseGlow {
          0%, 100% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.1);
            opacity: 1;
          }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        .loading-logo-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .loading-logo-pulse {
          animation: pulseGlow 1.8s ease-in-out infinite;
        }

        .loading-logo-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 32px rgba(41, 90, 167, 0.12);
          border: 2px solid ${COLORS.primary}20;
          animation: float 2.5s ease-in-out infinite;
          position: relative;
        }

        .loading-logo-circle::after {
          content: '';
          position: absolute;
          top: -3px;
          left: -3px;
          right: -3px;
          bottom: -3px;
          border-radius: 50%;
          border: 2px solid transparent;
          border-top-color: ${COLORS.primary};
          border-right-color: ${COLORS.secondary};
          animation: spin 1.2s linear infinite;
        }

        .loading-dots span {
          display: inline-block;
          animation: bounce 1.4s ease-in-out infinite;
          font-size: 1.6rem;
          line-height: 1;
          margin-left: 1px;
        }
        .loading-dots span:nth-child(1) { animation-delay: 0s; }
        .loading-dots span:nth-child(2) { animation-delay: 0.2s; }
        .loading-dots span:nth-child(3) { animation-delay: 0.4s; }

        @keyframes bounce {
          0%, 80%, 100% { transform: scale(1); opacity: 0.3; }
          40% { transform: scale(1.2); opacity: 1; }
        }

        .loading-progress-track {
          box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
        }
      `}</style>

      <Footer />
    </>
  );
}

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* ===== EN‑TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier l\'entrée' : 'Nouvelle entrée'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-information-line"></i>
                    {id ? 'Modification' : 'Création'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i>
                    {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/finances/entrees')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== NOTIFICATIONS ===== */}
          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Entrée enregistrée avec succès. Redirection...</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> Informations de l'entrée
                </Card.Header>
                <Card.Body className="card-body-modern">
                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={12}>
                        <Form.Group controlId="date_at">
                          <Form.Label className="form-label-modern">
                            Date du culte <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-calendar-line input-icon"></i>
                            <Form.Control
                              type="date"
                              name="date_at"
                              value={formData.date_at}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.date_at}
                              className="form-control-modern with-icon"
                            />
                            {validationErrors.date_at && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.date_at}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group controlId="matri_revenu">
                          <Form.Label className="form-label-modern">
                            Type de revenu <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-price-tag-3-line input-icon"></i>
                            <Form.Select
                              name="matri_revenu"
                              value={formData.matri_revenu}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.matri_revenu}
                              className="form-select-modern with-icon"
                            >
                              <option value="">Sélectionner un type</option>
                              {typesRevenus.map(type => (
                                <option key={type.matricule} value={type.matricule}>
                                  {type.intitule} ({type.matricule})
                                </option>
                              ))}
                            </Form.Select>
                            {validationErrors.matri_revenu && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.matri_revenu}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group controlId="total">
                          <Form.Label className="form-label-modern">
                            Montant (FCFA) <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-money-euro-circle-line input-icon"></i>
                            <Form.Control
                              type="number"
                              name="total"
                              value={formData.total}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.total}
                              min="1"
                              step="1"
                              className="form-control-modern with-icon"
                              placeholder="0"
                            />
                            {validationErrors.total && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.total}
                              </Form.Control.Feedback>
                            )}
                          </div>
                          <Form.Text className="form-text-modern">
                            Montant en Fcfa
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group controlId="matri_eglise">
                          <Form.Label className="form-label-modern">
                            Temple <span className="required">*</span>
                          </Form.Label>
                          <div className="input-icon-wrapper">
                            <i className="ri-building-2-line input-icon"></i>
                            <Form.Select
                              name="matri_eglise"
                              value={formData.matri_eglise}
                              onChange={handleInputChange}
                              isInvalid={!!validationErrors.matri_eglise}
                              className="form-select-modern with-icon"
                            >
                              <option value="">Sélectionner un temple</option>
                              {temples.map(temple => (
                                <option key={temple.matricule} value={temple.matricule}>
                                  {temple.nom} - {temple.ville}
                                </option>
                              ))}
                            </Form.Select>
                            {validationErrors.matri_eglise && (
                              <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                {validationErrors.matri_eglise}
                              </Form.Control.Feedback>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={12} className="mt-3">
                        <div className="d-flex justify-content-end gap-3">
                          <Button
                            variant="light"
                            onClick={() => navigate('/finances/entrees')}
                            disabled={saving}
                            className="btn-modern-outline"
                          >
                            <i className="ri-close-line me-1"></i> Annuler
                          </Button>
                          <Button
                            type="submit"
                            disabled={saving}
                            className="btn-modern-success"
                          >
                            {saving ? (
                              <><Spinner size="sm" className="me-1" /> {id ? 'Modification...' : 'Enregistrement...'}</>
                            ) : (
                              <><i className="ri-check-line me-1"></i> {id ? 'Modifier l\'entrée' : 'Ajouter l\'entrée'}</>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}